import { Unstable_Grid2 as Grid } from "@mui/material";
import CreateReleaseFilter from "./createreleasefilter";
import ReleaseSettings from "./releasesettings";
import ReleaseTables from "./releasetables";
import { createContext, useState } from "react";
import { ReleaseTable } from "../../../data/interfaces/jobmodels";
import { DropdownModel } from "../../../data/interfaces/sharedmodels";




export default function CreateReleaseJob() {
    
    return (
        
            <Grid container spacing={1}>
                <Grid xs={3}>
                    <CreateReleaseFilter />
                </Grid>
                <Grid xs={6}>
                    <ReleaseSettings />
                </Grid>
                <Grid xs={3}>
                    <ReleaseTables />
                </Grid>
            </Grid>
    )
}